import { setAPI, setTopLevelCallers } from '../api/api';
import { addToNREUM, gosCDN, gosNREUMInitializedAgents } from '../../common/window/nreum';
import { setConfiguration, setInfo, setLoaderConfig, setRuntime } from '../../common/config/config';
import { activateFeatures, activatedFeatures } from '../../common/util/feature-flags';
import { isWorkerScope } from '../../common/util/global-scope';
export function configure(agentIdentifier) {
  let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let loaderType = arguments.length > 2 ? arguments[2] : undefined;
  let forceDrain = arguments.length > 3 ? arguments[3] : undefined;
  let {
    init,
    info,
    loader_config,
    runtime = {
      loaderType
    },
    exposed = true
  } = opts;
  const nr = gosCDN();
  if (!info) {
    init = nr.init;
    info = nr.info;
    loader_config = nr.loader_config;
  }
  info.jsAttributes ??= {};
  if (isWorkerScope) {
    // add a default attr to all worker payloads
    info.jsAttributes.isWorker = true;
  }
  setInfo(agentIdentifier, info);
  setConfiguration(agentIdentifier, init || {});
  setLoaderConfig(agentIdentifier, loader_config || {});
  setRuntime(agentIdentifier, runtime);
  setTopLevelCallers();
  const api = setAPI(agentIdentifier, forceDrain);
  gosNREUMInitializedAgents(agentIdentifier, api, 'api');
  gosNREUMInitializedAgents(agentIdentifier, exposed, 'exposed');
  addToNREUM('activatedFeatures', activatedFeatures);
  addToNREUM('setToken', flags => activateFeatures(flags, agentIdentifier));
  return api;
}